module.exports = __webpack_public_path__ + "static/band-6090a7993ddb6ccc2fad5c53524bb78d.jpg";